<app-assistance-iberdrola
  [assistanceUser]="'true'"
  [listAttendancesUser]="listAttendancesUser"
></app-assistance-iberdrola>
